import * as React from 'react';
import Box from '../../../parts/Box';

import {IInputComponentPropsData, IInputComponentPropsFunctions} from '../props/IInputComponentProps';
import {IInputJobSettingsPropsData, IInputJobSettingsPropsFunctions} from '../props/IInputJobSettingsProps';
import { ISummaryComponentPropsData, ISummaryComponentPropsFunctions } from "../../SummaryPage/props/ISummaryComponentProps";
import { IIdentificationOfConsensusResiduesData, IIdentificationOfConsensusResiduesFunctions } from "../props/IIdentificationOfConsensusResiduesProps";


import { Container, Col, Button, Row,  Form, FormGroup, Label, Input, Card, CardTitle, CardBody } from 'reactstrap';
import HelpTooltip from '../../../commons/HelpTooltip';

interface IIdentificationOfConsensusResidues {
    majorityConsensusMinIdentity : number,
    ratioConsensusMinFreq: number,
    ratioConsensusMinRatio: number,
    globalConsensusGapThreshold: number,
}

type IProps = IIdentificationOfConsensusResidues & IInputJobSettingsPropsData & IInputJobSettingsPropsFunctions & 
            IIdentificationOfConsensusResiduesData & IIdentificationOfConsensusResiduesFunctions & 
            IInputComponentPropsData & IInputComponentPropsFunctions & IInputComponentPropsFunctions & 
            ISummaryComponentPropsData & ISummaryComponentPropsFunctions & { history: any };


// InputComponent state is used to be provided as the context for child components


export default class identificationOfConsensusResidues extends React.Component< IProps> {

    infoRef = React.createRef<HTMLFormElement>();
/*---------------------------------------------------------------------------------------------------------------------------------- */
    render() {

        return  <div>
                    <Box title = "IDENTIFICATION OF CONSENSUS RESIDUES">                       
                    <Form>
                            <Container>
                                <Row >
                
                                    <Col>          
                                    <Card>
                                        <CardBody>
                                        <CardTitle tag="h5">
                                            Majority consensus
                                        </CardTitle>
                                        <Row>       
                                        <Col>
                                        <Label htmlFor="minIdentityField" style = {{color: "#09A0A8", paddingLeft: "4px"}} >Minimal identity (%):
                                                    <HelpTooltip>
                                                    All non-wild-type residues that occur at a given position in at least n % of analyzed 
                                                    sequences will be assigned as the "majority consensus" residues (n = the specified value)
                                                    </HelpTooltip> 
                                                </Label>
                                        </Col>                    
                                        <form id="ll-input-info" ref={this.infoRef}>
                                            <div className="form-group">
                                                
                                                <input type="text" className="form-control" id="min_identity"
                                                    style = {{width: "75px" , height: "30px"}}
                                                    value={this.props.majorityConsensusMinIdentity}
                                                    onChange={evt => this.props.changeMajorityConsensusMinIdentity(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form>
                                        </Row>      

                                    
                                        </CardBody>
                                    </Card>
                                                
                                           
                                    </Col>
                                     


                                    <Col>
                                    <Card>
                                        <CardBody>
                                        <CardTitle tag="h5">
                                            Ratio consensus
                                        </CardTitle>         
                                        <Row>       
                                        <Col>
                                                <Label htmlFor="maxNumSeqField" style = {{color: "#09A0A8"}} >
                                                    Minimal frequency (%):
                                                    <HelpTooltip>
                                                    All residues that occur at a given position in at least f % of 
                                                    analyzed sequences and, at the same time, are at this position 
                                                    at least r times more frequent than the wild-type residue will 
                                                    be assigned as the "ratio consensus" residues (f = the value specified 
                                                    by the "Minimal frequency" parameter, r = the value specified 
                                                    by the "Minimal ratio" parameter)
                                                    </HelpTooltip>
                                                </Label>
                                        </Col>                    
                                        <form id = "ll-input-info" ref={this.infoRef}>
                                            <div className = "form-group">                                               
                                                <input type="text" className="form-control" id="blast_e_text" name = "grp1"
                                                    style = {{width: "75px" , height: "30px"}} 
                                                    value={this.props.ratioConsensusMinFreq}
                                                    onChange={evt => this.props.changeRatioConsensusMinFreq(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form> 
                                        </Row>      

                                         <Row>
                                            <Col>
                                                <Label htmlFor="maxNumSeqField" style = {{color: "#09A0A8"}} >
                                                    Minimal ratio:
                                                    <HelpTooltip>
                                                    All residues that occur at a given position in at least 
                                                    f % of the analyzed sequences and, at the same time, are 
                                                    at this position at least r times more frequent than the 
                                                    wild-type residue will be assigned as the "ratio consensus" 
                                                    residues (f = the value specified by the "Minimal frequency" 
                                                    parameter, r = the value specified by the "Minimal ratio" parameter).
                                                    </HelpTooltip>
                                                </Label>
                                            </Col>
                                            <form id="ll-input-info" ref={this.infoRef}>
                                            <div className="form-group">
                                                
                                                <input type="text" className="form-control" id="max_num_seq"
                                                    style = {{width: "75px" , height: "30px"}}
                                                    value={this.props.ratioConsensusMinRatio}
                                                    onChange={evt => this.props.changeRatioConsensusMinRatio(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                            </form>    
                                        </Row>

                                        </CardBody>
                                    </Card>
                                    </Col>

                                    <Col >
                                       <Card>
                                        <CardBody>
                                        <CardTitle tag="h5">
                                            Global consensus
                                        </CardTitle>         
                                        <Row>       
                                        <Col>
                                                <Label htmlFor="maxNumSeqField" style = {{color: "#09A0A8"}} >
                                                    Gap threshold (%):
                                                    <HelpTooltip>
                                                    All positions of multiple sequence alignment with the gap 
                                                    occurrence above the specified threshold will be excluded from the analysis.
                                                    </HelpTooltip>
                                                </Label>
                                        </Col>                    
                                        <form id = "ll-input-info" ref={this.infoRef}>
                                            <div className = "form-group">                                               
                                                <input type="text" className="form-control" id="blast_e_text" name = "grp1"
                                                    style = {{width: "75px" , height: "30px"}} 
                                                    value={this.props.globalConsensusGapThreshold}
                                                    onChange={evt => this.props.changeGlobalConsensusGapThreshold(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form> 
                                        </Row>      
                                        </CardBody>
                                    </Card>
                                    </Col> 
                                </Row>
                            </Container>
                        </Form>
                    </Box>
                    </div>
}}
